import { useEffect, useState } from "react";
import useData from "./useData";
import usePage from "./usePage";

import useUser from "./useUser";

const usePayrollExport = () => {
  const { executeAction } = useData();
  const { showMessage } = usePage();
  const { getUser, user } = useUser();

  const [exports, setExports] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUser();
  }, []);

  // Request export - creates work queue entry
  const requestExport = async (layout, payPeriodId, email, filters) => {
    setLoading(true);
    try {
      const data = {
        layout,
        payPeriodId,
        userId: user?._id,
        email,
        filters: filters || {},
      };

      const results = await executeAction({
        entityName: "PayTransaction",
        action: "requestExport",
        data: data,
      });

      if (results?.isSuccessful) {
        showMessage(
          "Export requested successfully. You will receive an email when ready.",
          "success"
        );
        // Refresh history
        // await getExportHistory(payPeriodId);
        // return results.data;
      } else {
        showMessage(results?.message || "Failed to request export", "error");
      }
    } catch (err) {
      showMessage(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // Get export history for a pay period
  const getExportHistory = async (payPeriodId, layout) => {
    setLoading(true);
    try {
      const results = await executeAction({
        entityName: "PayTransaction",
        action: "getExportHistory",
        data: {
          payPeriodId,
          ...(layout && { layout }),
        },
      });

      if (results?.isSuccessful) {
        const dataArray = Array.isArray(results.data)
          ? results.data
          : Object.values(results.data || {}).filter(
              (item) =>
                typeof item === "object" && item !== null && !item.isSuccessful
            );
        setExports(dataArray);
        return dataArray;
      }
    } catch (err) {
      showMessage(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // Get single export details
  const getExportDetails = async (exportHistoryId) => {
    setLoading(true);
    try {
      const results = await executeAction({
        entityName: "PayTransaction",
        action: "getExportDetails",
        data: { exportHistoryId },
      });

      if (results?.isSuccessful) {
        return results.data;
      } else {
        showMessage(
          results?.message || "Failed to get export details",
          "error"
        );
      }
    } catch (err) {
      showMessage(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // Retry failed export
  const retryExport = async (exportHistoryId) => {
    setLoading(true);
    try {
      const results = await executeAction({
        entityName: "PayTransaction",
        action: "retryExport",
        data: { exportHistoryId },
      });

      if (results?.isSuccessful) {
        showMessage("Export retry queued successfully", "success");
        return results.data;
      } else {
        showMessage(results?.message || "Failed to retry export", "error");
      }
    } catch (err) {
      showMessage(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    exports,
    loading,
    requestExport,
    getExportHistory,
    getExportDetails,
    retryExport,
  };
};

export default usePayrollExport;
